import React, { PropsWithChildren, useContext } from "react";

import { Resource } from "@examspark/types";

import { useSearch } from "./useSearch";

export type SearchResults = {
  aggregations?: {
    [key: string]: {
      key: string;
      count: number;
    }[];
  } | null;
  items: Resource[];
  nextToken?: string;
  total: number;
};

/** This isn't typesafe in 17/18 hybrid environments */
export const SearchContext = React.createContext<
  ReturnType<typeof useSearch> | undefined
>(undefined);

export const useSearchContext = () => {
  return useContext(SearchContext);
};

export const SearchContextProvider = (
  props: PropsWithChildren<{
    value: ReturnType<typeof useSearch>;
  }>,
) => {
  return (
    <SearchContext.Provider value={props.value}>
      {props.children}
    </SearchContext.Provider>
  );
};
